/**
 * Parse mobile log tag into display label + optional task id.
 * Example: "song_audio_not_found:d07dc0d1…" → { tagLabel, taskId }
 */
const REASON_TAG_PATTERN = /^([a-z0-9_]+):([a-f0-9]{16,})$/i;

export function parseLogTag(item) {
  if (!item) return { tagLabel: null, taskId: null };

  let raw = '';
  if (typeof item.tag === 'string' && item.tag.trim()) {
    raw = item.tag.trim();
  } else if (typeof item.reason === 'string' && item.reason.trim()) {
    const trimmedReason = item.reason.trim();
    if (REASON_TAG_PATTERN.test(trimmedReason)) {
      raw = trimmedReason;
    }
  }

  if (raw) {
    const colon = raw.indexOf(':');
    if (colon > 0) {
      const tagLabel = raw.slice(0, colon);
      const taskId = raw.slice(colon + 1).trim();
      if (taskId) return { tagLabel, taskId };
      return { tagLabel, taskId: null };
    }
    return { tagLabel: raw, taskId: null };
  }

  const reason = item.reason;
  if (reason && typeof reason === 'object') {
    const taskId =
      reason.task_id ||
      reason.taskId ||
      (reason.data && (reason.data.task_id || reason.data.taskId)) ||
      null;
    const tagLabel =
      reason.error_type ||
      reason.errorType ||
      reason.type ||
      null;
    return {
      tagLabel: tagLabel ? String(tagLabel) : null,
      taskId: taskId ? String(taskId) : null,
    };
  }

  return { tagLabel: null, taskId: null };
}

export function tagPrefix(tagOrLabel) {
  if (!tagOrLabel || typeof tagOrLabel !== 'string') return '';
  const i = tagOrLabel.indexOf(':');
  return (i > 0 ? tagOrLabel.slice(0, i) : tagOrLabel).trim();
}
